import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"font-size":"14px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_Navi = _resolveComponent("Navi")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"height":"100%"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { style: {"color":"#FFF","display":"flex","flex-direction":"row","justify-content":"space-between"} }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"color":"#FFF","font-size":"20px","font-weight":"bold"} }, "炫图 AI", -1)),
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_1, "当前用户: " + _toDisplayString(_ctx.nickname) + " (" + _toDisplayString(_ctx.department) + ")", 1),
                _createVNode(_component_a_button, {
                  type: "link",
                  onClick: _ctx.handleLogout
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("退出", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          (!_ctx.isMobileView)
            ? (_openBlock(), _createBlock(_component_a_layout_sider, {
                key: 0,
                collapsible: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Navi)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_layout_content, null, {
            default: _withCtx(() => [
              (_ctx.isMobileView)
                ? (_openBlock(), _createBlock(_component_Navi, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_layout_content, {
                class: "main-container",
                style: {"min-height":"200px","overflow":"scroll"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view),
                  _createVNode(_component_a_layout_footer, null, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("div", { style: {"text-align":"center"} }, " 2025©copyright Xuantu ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}